import { Heading, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { usePathname } from "../../../hooks/usePathname";
import { Pathname } from "../../../enums";

export const SignInHeader = () => {
  const { t } = useTranslation("signinpage");
  const { pathname } = usePathname();
  return (
    <Layout.Item className="u-text-center">
      <Heading level={1}>{t("header")}</Heading>
      <p>{t("subheader.header1")}</p>
      <p> {t("requiredMessage")}</p>
      {pathname === Pathname.FLEET && <p>{t("subheader.header3")}</p>}
      <p>
        <Link
          target="_blank"
          to={
            "https://www.vwfs.fr/vwfs-service-paiement/politique-donnees.html"
          }
        >
          {t("subheader.header2")}
        </Link>
      </p>
    </Layout.Item>
  );
};

export default SignInHeader;
